<template>
  <footer class="container">
    <div class="inner-container">
      <div style="display: flex">
        <div style="width: 760px">
          <h4 class="footer-title"
              style="font-family: MeituanType-Regular">
            美团地图
          </h4>
        </div>
        <div style="width: 200px">
          <h4 class="footer-title"
              style="font-size: 18px">新手入门</h4>
          <p class="footer-content footer-content-router"
             style="margin-top: 24px"
             @click="goRouter('/service/search')">
            产品与服务
          </p>
          <p class="footer-content footer-content-router"
             @click="goRouter('/support/search')">
            开发文档
          </p>
        </div>
        <div>
          <h4 class="footer-title"
              style="font-size: 18px">联系我们</h4>
          <p class="footer-content"
             style="margin-top: 24px">
            hanzheng03@meituan.com<br>
          </p>
        </div>
      </div>
      <p class="footer-content"
         style="margin-top: 24px">
        Copyright © 2022 美团
      </p>
    </div>
  </footer>
</template>
<script>
export default {
  methods: {
    goRouter(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background: #1a1a1a;
  display: flex;
  justify-content: center;
  .inner-container {
    width: 1200px;
    height: 260px;
    padding: 40px 36px;
    .footer-title {
      font-size: 20px;
      color: #fff;
      font-weight: 400;
      line-height: 28px;
    }
    .footer-content {
      opacity: 0.72;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      font-weight: 400;
      line-height: 20px;
    }
    .footer-content-router:hover {
      cursor: pointer;
    }
  }
}
</style>
